export const DEFAULT_UNIX_TIMESTAMP = 2147483647;

export const CURRENCIES = {
  USD: 'USD',
};

export const CURRENCY_CONFIG = {
  USD: { locale: 'en-US', decimals: 2, divisor: 100 },
};

export const DEFAULT_CURRENCY_OPTIONS = {
  notation: 'compact',
  compactDisplay: 'short',
};

export const DURATION_TIME_UNITS = {
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  HOUR: 'hour',
  MINUTE: 'minute',
};

export const SHORT_DURATIONS = [
  DURATION_TIME_UNITS.MONTH,
  DURATION_TIME_UNITS.WEEK,
  DURATION_TIME_UNITS.HOUR,
  DURATION_TIME_UNITS.MINUTE,
];

export const LONG_DURATIONS = [
  DURATION_TIME_UNITS.YEAR,
  DURATION_TIME_UNITS.MONTH,
  DURATION_TIME_UNITS.WEEK,
  DURATION_TIME_UNITS.DAY,
];
